import Page from './Page'

const Members = () => {
	return <Page>Coming Soon</Page>
}

export default Members
